export default __webpack_public_path__ + "24c3eaae7a5f7468a7234f2127df4e93.svg";